export default "__VITE_ASSET__CgqYsNKt__"